type SchemaOptionValue = string | number;

interface SchemaOption {
  id: SchemaOptionValue;
  name: string;
}

interface SchemaField {
  [key: string]: unknown;
}

interface SchemaWithProperties {
  properties: Record<string, SchemaField>;
  [key: string]: unknown;
}

interface SchemaValues {
  enum: Array<SchemaOptionValue>;
  enumNames: Array<string>;
  oneOf: Array<{ const: SchemaOptionValue; title: string }>;
}

export function addValuesToSchema(
  field: string,
  parent: Array<SchemaOption>,
  schema: SchemaWithProperties,
): SchemaWithProperties {
  const values = parent.reduce(
    (acc, value) => {
      acc.enum.push(value.id);
      acc.enumNames.push(value.name);
      acc.oneOf.push({
        const: value.id,
        title: value.name,
      });

      return acc;
    },
    {
      enum: [],
      enumNames: [],
      oneOf: [],
    } satisfies SchemaValues,
  );

  return {
    ...schema,
    properties: {
      ...schema.properties,
      [field]: {
        ...schema.properties[field],
        oneOf: values.oneOf,
        enumNames: values.enumNames,
      },
    },
  };
}
